import { Helmet } from 'react-helmet-async'

const SITE = 'https://www.uben.online'
const DEFAULT_TITLE = 'Uben — Free FSRS Spaced Repetition Flashcards & Anki Alternative'
const DEFAULT_DESC = 'Master languages, medical terms & coding 2x faster with Uben. Modern FSRS spaced repetition, 1-click Anki (.apkg) import, Kindle export & 1,000+ free community decks.'
const DEFAULT_IMAGE = `${SITE}/assets/og-card.png`

const SEO = ({ title, description, image, url, type = 'website' }) => {
  const pageTitle = title ? (title.includes('Uben') ? title : `${title} | Uben`) : DEFAULT_TITLE
  const pageDesc = description || DEFAULT_DESC
  const pageImage = image || DEFAULT_IMAGE
  const pageUrl = url || SITE

  return (
    <Helmet>
      <title>{pageTitle}</title>
      <meta name="description" content={pageDesc} />
      <link rel="canonical" href={pageUrl} />

      <meta property="og:type" content={type} />
      <meta property="og:url" content={pageUrl} />
      <meta property="og:title" content={pageTitle} />
      <meta property="og:description" content={pageDesc} />
      <meta property="og:image" content={pageImage} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:image:alt" content={pageTitle} />
      <meta property="og:image:type" content="image/png" />
      <meta property="og:site_name" content="Uben" />
      <meta property="og:locale" content="en_US" />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={pageUrl} />
      <meta name="twitter:title" content={pageTitle} />
      <meta name="twitter:description" content={pageDesc} />
      <meta name="twitter:image" content={pageImage} />
      <meta name="twitter:image:alt" content={pageTitle} />
    </Helmet>
  )
}

export default SEO

